import { Component, OnInit } from '@angular/core';
import {ChargedActModel} from '../../entity/chargedAct.model';
import {IDialogComponent} from '../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../common/dialog/dialogWithInput';
import {ChargedActFindOneByIdService} from '../../../impl/service/chargedActFindOneById.service';
import {FormArray, FormBuilder, FormControl, FormGroup, UntypedFormGroup, Validators} from '@angular/forms';
import {ToastControl} from '../../../../../../controls/core/toast/toast.control';
import {SALE_DIRECTION} from '../../../../../sale/api/entity/sale.model';
import {SaleSummaryModel} from '../../../../../sale/api/entity/saleSummary.model';
import {MomentAdapter} from '../../../../../../shared/utils/moment.utils';
import {ChargedActSetCompletedService} from '../../../impl/service/chargedActSetCompleted.service';
import {ChargedActSetCompletedPayload} from '../../../impl/service/payload/chargedActSetCompleted.payload';
import {
  SaleCreateSimplePaymentRequestPayload
} from '../../../../../sale/impl/service/payload/save/simple/saleCreateSimplePaymentRequest.payload';
import {
  SaleCreateSimplePaymentPayload
} from '../../../../../sale/impl/service/payload/save/simple/saleCreateSimplePayment.payload';

export interface ChargedActAcceptDialogInput {
  id: number;
}

export interface ChargedActAcceptDialogResult {
  chargedAct: ChargedActModel;
}

@Component({
  templateUrl: './charged-act-accept-dialog.component.html',
  styles: [
  ],
  providers: [
    ChargedActFindOneByIdService,
    ChargedActSetCompletedService,
  ]
})
export class ChargedActAcceptDialogComponent implements
    IDialogComponent<ChargedActAcceptDialogInput, ChargedActAcceptDialogResult>, OnInit {
  dialog: DialogWithInput<ChargedActAcceptDialogInput, ChargedActAcceptDialogResult>;

  formGroup: FormGroup;
  chargedAct: ChargedActModel;

  SALE_DIRECTION_OUT = SALE_DIRECTION.SALE_DIRECTION_OUT;

  constructor(public findOneService: ChargedActFindOneByIdService,
              private formBuilder: FormBuilder,
              private toastControl: ToastControl,
              public chargedActSetCompletedService: ChargedActSetCompletedService) {
    this.formGroup = this.formBuilder.group({
      id: new FormControl(undefined, Validators.required),
      date: new FormControl(MomentAdapter.current().get(), Validators.required),
      responsibleUserId: new FormControl(undefined, Validators.required),
      saleId: new FormControl(undefined, Validators.required),
      comment: new FormControl(undefined),
      payment: this.formBuilder.group({}),
      amount: new FormControl(),
      advance: new FormControl(0)
    });
  }

  ngOnInit(): void {
  }

  entityLoaded(entity: ChargedActModel) {
    this.chargedAct = entity;
    if (entity.sale.isWaitingForConfirmation()) {
      this.formGroup.patchValue({
        id: entity.id,
        responsibleUserId: entity.sale.responsibleUser?.id,
        saleId: entity.sale.id,
        comment: entity.comment,
      });
      this.saleUpdated(entity.sale);
    } else {
      this.dialog.close(undefined);
      this.toastControl.presentError(undefined, 'Cet acte n\'est pas en attente de confirmation du patient');
    }
  }

  saleUpdated(sale: SaleSummaryModel) {
    this.formGroup.patchValue({
      amount: sale.totalPriceVatIncluded
    });
  }

  buildPayload = (): ChargedActSetCompletedPayload => {
    const payload: ChargedActSetCompletedPayload = {
      comment: this.formGroup.get('comment').value,
      date: this.formGroup.get('date').value,
      responsibleUserId: this.formGroup.get('responsibleUserId').value,
      id: this.formGroup.get('id').value,
      paymentRequests: [],
    };

    payload.paymentRequests = (this.formGroup.get('payment.paymentRequests') as FormArray)
        .controls.map((paymentRequestFormGroup: UntypedFormGroup) => {
      const paymentRequestPayload = new SaleCreateSimplePaymentRequestPayload();
      paymentRequestPayload.amount = paymentRequestFormGroup.controls.amount.value;
      paymentRequestPayload.deadline = paymentRequestFormGroup.controls.deadline.value;
      paymentRequestPayload.label = paymentRequestFormGroup.controls.label.value;
      paymentRequestPayload.onlinePayment = paymentRequestFormGroup.controls.onlinePayment.value;

      const paymentFormGroup: UntypedFormGroup = paymentRequestFormGroup.get('accountingMovement') as UntypedFormGroup;
      if (paymentFormGroup) {
        const paymentPayload = new SaleCreateSimplePaymentPayload();
        paymentPayload.paymentTypeValue = paymentFormGroup.controls.paymentTypeValue.value;
        paymentPayload.check = paymentFormGroup.get('check')?.value;
        paymentPayload.accountId = paymentFormGroup.controls.accountId.value;
        paymentPayload.date = paymentFormGroup.controls.date.value;
        paymentRequestPayload.payment = paymentPayload;
      }
      return paymentRequestPayload;
    });
    return payload;
  }

  actionError(error: any) {
    this.toastControl.presentError(error);
  }

  actionDone(chargedAct: ChargedActModel) {
    console.log('accepted action done');
    this.dialog.close({
      chargedAct
    });
  }

}
